import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AccountDeletionReasonService } from 'modules/crm/settings/account-deletion-reason/services';
import { ACCOUNT_DELETION_REASONS_LIST_KEY } from 'modules/crm/settings/account-deletion-reason/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteAccountDeletionReason = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('accountDeletionReason');
  return useMutation(() => AccountDeletionReasonService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [ACCOUNT_DELETION_REASONS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
